import axios from 'axios';

import {showMessageFromResponse, showRequestErrorMessage} from 'shared/utils/show-message-from-response';

import {IGetRisksRequestsArgs, RisksRequestsApi} from '../api';
import {IUpdateActiveArgs, ISendServiceArgs} from '../api/types';

export const RisksRequestsService = {
    get: async (args?: IGetRisksRequestsArgs) => {
        try {
            return await RisksRequestsApi.getData(args);
        } catch (e) {
            console.error(e);
            if (axios.isAxiosError(e)) showRequestErrorMessage(e);
            throw e;
        }
    },

    getById: async (id: number) => {
        try {
            return await RisksRequestsApi.getById(id);
        } catch (e) {
            console.error(e);
            if (axios.isAxiosError(e)) showRequestErrorMessage(e);
            throw e;
        }
    },

    refresh: async (id: number) => {
        try {
            const response = await RisksRequestsApi.refreshRequest(id);
            showMessageFromResponse({response});
        } catch (e) {
            console.error(e);
            if (axios.isAxiosError(e)) showRequestErrorMessage(e);
            throw e;
        }
    },

    updateActive: async (args: IUpdateActiveArgs) => {
        try {
            const response = await RisksRequestsApi.updateDocsActive(args);
            showMessageFromResponse({response});
        } catch (e) {
            console.error(e);
            if (axios.isAxiosError(e)) showRequestErrorMessage(e);
            throw e;
        }
    },

    sendService: async (values: ISendServiceArgs) => {
        try {
            const response = await RisksRequestsApi.sendService(values);

            showMessageFromResponse({response});
        } catch (e) {
            console.error(e);
            if (axios.isAxiosError(e)) showRequestErrorMessage(e);
            throw e;
        }
    },
};
